/*=========================================================================================
	File Name: moduleAuthGetters.js
	Description: Auth Module Getters
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
	isInCart: state => itemId => {
		if (state.AcceptedBarcodes)
			return state.AcceptedBarcodes.some((item) => item.barcode === itemId)
	},

}
